@let selected = value();

<div class="grid-cols-1 md:grid-cols-{{ cols() }} grid gap-x-8 gap-y-6">
  @for (chip of state$ | async; track trackByValue($index, chip)) {
    <span [matTooltip]="chip.tooltip">
      <button
        mat-flat-button
        [disabled]="chip.disabled"
        class="!w-full !text-base !font-normal !px-0"
        [class.btn-header-selected]="chip.value === selected"
        [class.btn-header]="chip.value !== selected"
        [class.!border-red-500]="invalid()"
        (click)="toggle(chip.value, $event)"
      >
        {{ chip.label }}
      </button>
    </span>
  }
</div>
